import { SeverityType } from '@/services/warnings/warningDefinitions';
import { WorkingShift } from '@/types/daily.types';
import { secondsToHours, secondsToMinutes } from 'date-fns';
import { RosterWarningModel, WarningsProps } from '../warnings.types';

export const getBreakLimitsWarning = (shift: WorkingShift, props: WarningsProps): RosterWarningModel | undefined => {
  const { strings, breakSettings } = props;

  const severity = breakSettings.severeBreakWarnings ? SeverityType.CRITICAL : SeverityType.WARNING;

  const shiftLength = (shift.end || 0) - (shift.start || 0);
  const totalBreakTime = shift.breaks.reduce((prevTotal, brek) => {
    return prevTotal + brek.end - brek.start;
  }, 0);

  const longestBreak = Math.max(...shift.breaks.map(b => b.end - b.start), 0);

  const breakTime = breakSettings.canSplitBreaks ? totalBreakTime : longestBreak;

  let shiftWarning: RosterWarningModel | undefined = undefined;

  breakSettings.breakLengthLimits.forEach(limit => {
    if (shiftLength > limit.minimumShiftLength) {
      if (breakTime < limit.minimumBreakLength) {
        shiftWarning = {
          severity,
          name: breakSettings.canSplitBreaks
            ? strings.breakMinimumSplit(
                secondsToHours(limit.minimumShiftLength),
                secondsToMinutes(limit.minimumBreakLength)
              )
            : strings.breakMinimumSingle(
                secondsToHours(limit.minimumShiftLength),
                secondsToMinutes(limit.minimumBreakLength)
              ),
          shiftId: shift.id
        };
      }
    }
  });

  return shiftWarning;
};
